<form #journalVoucherForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/journal_voucher']">Journal Voucher</a> > {{ journal_voucher.voucher_number }}</h3>
    </div>
    <div class="form-actions" *ngIf="!['submitted','canceled'].includes(journal_voucher.status)">
      <button *ngIf="isFormDisabled && journal_voucher.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog(journal_voucher.id, 'submit')">
        <mat-icon>check_circle</mat-icon> Submit
      </button>
      <button *ngIf="isFormDisabled && journal_voucher.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="confirmDialog(journal_voucher.id, 'cancel')">Cancel</button>
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(journalVoucherForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Voucher No.</mat-label>
            <input #voucher_number="ngModel" [disabled]="true" type="text" matInput name="voucher_number" [(ngModel)]="journal_voucher.voucher_number" required>
            <mat-error *ngIf="voucher_number.invalid && voucher_number.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Voucher Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="journal_voucher.voucher_date" name="voucher_date" [matDatepicker]="voucher_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="voucher_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #voucher_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select #company_id (openedChange)="OnCompanyScroll($event)" [disabled]="isFormDisabled || disableCompanySelection" [(value)]="selectedCompany" (selectionChange)="onCompanyChange()">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="OnCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Credit Account -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <label class="field-label">Credit Account Type</label>
          <mat-radio-group name="credit_account_type" [(ngModel)]="selectedCreditType" required>
            <mat-radio-button value="internal">Internal&nbsp;&nbsp;</mat-radio-button>
            <mat-radio-button value="doctor">Doctor</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="selectedCreditType == 'doctor'">
          <div class="col-sm-4 mb-3">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Doctor Account</mat-label>
              <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedCreditDoctor">
                <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
                <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedCreditType == 'internal'">
          <div class="col-sm-4 mb-3">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Internal Account</mat-label>
              <mat-select #account_id (openedChange)="onAccountScroll($event)" [disabled]="isFormDisabled || disableAccountSelection" [(value)]="selectedCreditAccount">
                <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAccountKey($event)" matInput name="account_list">
                <mat-option *ngFor="let account of allAccounts" [value]="account.id">{{ account.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <!-- Debit Account -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <label class="field-label">Debit Account Type</label>
          <mat-radio-group name="debit_account_type" [(ngModel)]="selectedDebitType" required>
            <mat-radio-button value="internal">Internal&nbsp;&nbsp;</mat-radio-button>
            <mat-radio-button value="doctor">Doctor</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="selectedDebitType == 'doctor'">
          <div class="col-sm-4 mb-3">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Doctor Account</mat-label>
              <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDebitDoctor">
                <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
                <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedDebitType == 'internal'">
          <div class="col-sm-4 mb-3">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Internal Account</mat-label>
              <mat-select #account_id (openedChange)="onAccountScroll($event)" [disabled]="isFormDisabled || disableAccountSelection" [(value)]="selectedDebitAccount">
                <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAccountKey($event)" matInput name="account_list">
                <mat-option *ngFor="let account of allAccounts" [value]="account.id">{{ account.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Amount</mat-label>
            <input #amount="ngModel" type="number" matInput name="amount" [(ngModel)]="journal_voucher.amount">
            <mat-error *ngIf="amount.invalid && amount.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Narration</mat-label>
            <textarea #narration="ngModel" matInput name="narration" [(ngModel)]="journal_voucher.narration"></textarea>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="journal_voucher" [recordId]="journal_voucher.id"></app-audit-log-viewer>
</form>
